import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Styles/orderPage.css";
import Popup from "../Components/Popup";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import ReadMoreRoundedIcon from "@mui/icons-material/ReadMoreRounded";
import UpdateRounded from "@mui/icons-material/UpdateRounded";
import config from "../config";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";

function HomeBannerPage() {
  const [bannerData, setBannerData] = useState([]);
  const [buttonNewPopup, setButtonNewPopup] = useState(false);
  const [buttonShowPopup, setButtonShowPopup] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [newBannerSubmitted, setNewBannerSubmitted] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [bannerDetails, setBannerDetails] = useState({
    image: "",
    data: "",
  });

  const [filterActive, setFilterActive] = useState(1);
  const [filterBanners, setFilterBanners] = useState("");

  const handleSearchChange = (newFilteredData) => {
    console.log('newFilteredData', newFilteredData);
    setFilteredData(newFilteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalBanners = filteredData.length;
  const computedBanners = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    (currentPage - 1) * itemsPerPage + itemsPerPage
  );

  const handleImageChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      
      // Check file size (2MB = 2 * 1024 * 1024 bytes)
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      if (file.size > maxSize) {
        alert("Kích thước hình ảnh không được vượt quá 2MB. Vui lòng chọn hình ảnh khác.");
        e.target.value = ""; // Clear the file input
        return;
      }
      
      setImageFile(file);

      // Show loading state
      setBannerDetails({
        ...bannerDetails,
        image: "uploading...",
      });

      // Upload image immediately and set image to returned filename
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("file", file);
      formData.append("description", bannerDetails.data || "home banner");
      formData.append("clientDate", new Date().toISOString());

      try {
        const res = await axios.post(
          `${config.apiEndpoint}/HomeBanner/upload`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );
        // Extract the image property from the response object
        const imageName = res.data.image || res.data;
        setBannerDetails({
          ...bannerDetails,
          image: imageName,
        });
        console.log("Image uploaded successfully:", imageName);
      } catch (err) {
        console.error("Image upload failed:", err);
        setBannerDetails({
          ...bannerDetails,
          image: "",
        });
        setImageFile(null);
        alert("Image upload failed. Please try again.");
      }
    }
  };

  const addNewBanner = () => {
    const token = localStorage.getItem('token');
    console.log('bannerDetails', bannerDetails);
    axios
      .post(
        `${config.apiEndpoint}/HomeBanner`,
        {
          image: bannerDetails.image,
          data: bannerDetails.data,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          setBannerDetails({
            image: "",
            data: "",
          });
          setImageFile(null);
          console.log("New home banner added successfully");
          setButtonNewPopup(false);
          setNewBannerSubmitted(!newBannerSubmitted);
        }
      })
      .catch((err) => {
        console.error("Error adding new home banner:", err);
      });
  };

  const updateBanner = () => {
    const token = localStorage.getItem('token');
    const banner = bannerData[selectedBanner];
    
    // Use new uploaded image if available, otherwise keep existing image
    const finalImage = imageFile && bannerDetails.image ? bannerDetails.image : banner.image;
    
    axios
      .put(
        `${config.apiEndpoint}/HomeBanner/${banner.id}`,
        {
          id: banner.id,
          image: finalImage,
          data: bannerDetails.data,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          console.log("Home banner updated successfully");
          setButtonShowPopup(false);
          setBannerDetails({
            image: "",
            data: "",
          });
          setImageFile(null);
          setNewBannerSubmitted(!newBannerSubmitted);
        }
      })
      .catch((err) => {
        console.error("Error updating home banner:", err);
      });
  };

  const deleteBanner = (bannerId) => {
    const token = localStorage.getItem('token');
    axios
      .delete(`${config.apiEndpoint}/HomeBanner/${bannerId}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 204 || res.status === 200) {
          setNewBannerSubmitted(!newBannerSubmitted);
          console.log("Home banner removed successfully");
        }
      })
      .catch((err) => {
        console.error("Error removing home banner:", err);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${config.apiEndpoint}/HomeBanner`, { 
      headers: { Authorization: `Bearer ${token}` }, 
      withCredentials: true 
    })
      .then(res => {
        console.log('bannerData', res.data);
        setBannerData(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching home banners:", err);
      });
  }, [newBannerSubmitted]);

  return (
    <div className="bodyWrap">
      <div className="contentOrderWrap">
        <div className="leftSide">
          <h1>Home Banners</h1>
          <Pagination
            total={totalBanners}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
          <div className="orderNavWrap">
            <div className="orderNav">
              <ul>
                <li
                  className={`${filterActive === 1 ? "active" : ""}`}
                  onClick={() => {
                    setFilterBanners("");
                    setFilterActive(1);
                  }}
                >
                  All banners
                </li>
              </ul>
            </div>
            <div className="addOrderWrap">
              <SearchBar
                data={bannerData}
                handleSearchChange={handleSearchChange}
                dataType="homeBanner"
                status={filterBanners}
              />
              <button
                className="addOrder"
                onClick={() => {
                  setButtonNewPopup(true);
                }}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
          <div className="orderWrap">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Image</th>
                  <th>Description</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {computedBanners.map((banner) => {
                  return (
                    <tr key={banner.id}>
                      <td>
                        <font className="maincolor">#</font>
                        {banner.id}
                      </td>
                      <td>
                        {banner.image && (
                          <img
                            src={config.uploadEndpoint + "/" + banner.image}
                            alt={banner.data || "Home banner"}
                            style={{ width: "150px", height: "80px", objectFit: "cover", borderRadius: "4px" }}
                          />
                        )}
                      </td>
                      <td>{banner.data || "No description"}</td>
                      <td className="maincolor">
                        <button
                          className=""
                          style={{ marginRight: "20px" }}
                          onClick={() => deleteBanner(banner.id)}
                        >
                          <RemoveRoundedIcon />
                        </button>
                        <button
                          className=""
                          onClick={() => {
                            setButtonShowPopup(true);
                            setSelectedBanner(bannerData.indexOf(banner));
                            setImageFile(null);
                            setBannerDetails({
                              image: banner.image,
                              data: banner.data,
                            });
                          }}
                        >
                          <ReadMoreRoundedIcon />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add New Banner Popup */}
      <Popup trigger={buttonNewPopup} setTrigger={setButtonNewPopup}>
        <div className="popupWrap" style={{ height: "550px" }}>
          <div className="productSummary">
            <h3 className="productSummaryLeft">Add new home banner</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                <div className="input-group" style={{ marginTop: "10px" }}>
                  <textarea
                    placeholder="Description (optional)"
                    className="orderDetailsInput"
                    value={bannerDetails.data}
                    onChange={(e) =>
                      setBannerDetails({
                        ...bannerDetails,
                        data: e.target.value,
                      })
                    }
                    rows="3"
                    style={{ minHeight: "80px", resize: "vertical" }}
                  />
                </div>
                <div className="input-group">
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    className="orderDetailsInput"
                    onChange={handleImageChange}
                    required="required"
                  />
                  {bannerDetails.image && (
                    <div style={{ marginTop: 10 }}>
                      <p style={{ fontSize: "12px", color: "#007bff", marginBottom: "5px" }}>
                        {bannerDetails.image === "uploading..." ? "Uploading..." : "Uploaded image:"}
                      </p>
                      {bannerDetails.image === "uploading..." ? (
                        <div style={{ padding: "20px", textAlign: "center", color: "#007bff" }}>
                          <div>📤 Uploading image...</div>
                        </div>
                      ) : (
                        <img
                          src={config.uploadEndpoint + "/" + bannerDetails.image}
                          alt="Uploaded preview"
                          style={{ width: "100%", maxWidth: "400px", height: "auto", objectFit: "cover", borderRadius: "4px", border: "2px solid #28a745" }}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => addNewBanner()}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>

      {/* Edit Banner Popup */}
      <Popup trigger={buttonShowPopup} setTrigger={setButtonShowPopup}>
        <div className="popupWrap" style={{ height: "650px" }}>
          <div className="productSummary">
            <h3 className="productSummaryLeft">Edit home banner</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                {bannerData[selectedBanner] && bannerData[selectedBanner].image && (
                  <div className="input-group" style={{ marginTop: "10px" }}>
                    <p style={{ fontSize: "14px", color: "#666", marginBottom: "10px" }}>Current Image:</p>
                    <img
                      src={config.uploadEndpoint + "/" + bannerData[selectedBanner].image}
                      alt={bannerData[selectedBanner].data || "Current banner"}
                      style={{ width: "100%", maxWidth: "500px", height: "auto", borderRadius: "4px", marginBottom: "15px" }}
                    />
                  </div>
                )}
                <div className="input-group">
                  <textarea
                    placeholder="Description (optional)"
                    className="orderDetailsInput"
                    value={bannerDetails.data}
                    onChange={(e) =>
                      setBannerDetails({
                        ...bannerDetails,
                        data: e.target.value,
                      })
                    }
                    rows="3"
                    style={{ minHeight: "80px", resize: "vertical" }}
                  />
                </div>
                <div className="input-group">
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    className="orderDetailsInput"
                    onChange={handleImageChange}
                  />
                  {imageFile && (
                    <span style={{ marginTop: 10, fontSize: "12px", color: "#666" }}>
                      New image selected: {imageFile.name}
                    </span>
                  )}
                  {bannerDetails.image && imageFile && (
                    <div style={{ marginTop: 10 }}>
                      <p style={{ fontSize: "12px", color: "#007bff", marginBottom: "5px" }}>
                        {bannerDetails.image === "uploading..." ? "Uploading new image..." : "New uploaded image:"}
                      </p>
                      {bannerDetails.image === "uploading..." ? (
                        <div style={{ padding: "20px", textAlign: "center", color: "#007bff" }}>
                          <div>📤 Uploading new image...</div>
                        </div>
                      ) : (
                        <img
                          src={config.uploadEndpoint + "/" + bannerDetails.image}
                          alt="New uploaded"
                          style={{ width: "100%", maxWidth: "400px", height: "auto", borderRadius: "4px", border: "2px solid #007bff" }}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => updateBanner()}
              >
                <UpdateRounded />
                <span className="addOrderText">Update</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default HomeBannerPage;
